module.exports = __webpack_public_path__ + "img/world.06d12066.svg";